import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import Carregando from 'Component/Carregando';
import SemRegistros from 'Component/SemRegistros';
import Assinatura from 'Interface/Assinaturas';
import Avaliacao from 'Interface/Avaliacoes';
import Curso from 'Interface/Cursos';
import {
  useRecuperarAssinaturasQuery,
  useRecuperarAvaliacoesQuery,
  useRecuperarCursosQuery,
} from 'Service';

const Processar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const { slug = '' } = useParams();

  const {
    data: { assinaturas: [assinatura] } = { assinaturas: [{} as Assinatura] },
    isLoading: buscandoAssinatura,
  } = useRecuperarAssinaturasQuery();

  const { data: { cursos: [curso] } = { cursos: [{} as Curso] } } =
    useRecuperarCursosQuery({
      finder: 'slug',
      contain: ['Categorias', 'Modulos.Aulas'],
      options: { slug: { slug: slug } },
    });

  const {
    data: { avaliacoes: [avaliacao] } = { avaliacoes: [{} as Avaliacao] },
    isLoading: buscandoAvaliacao,
  } = useRecuperarAvaliacoesQuery(
    {
      finder: 'proximas',
      options: { curso_id: curso.id },
    },
    { skip: !curso.id }
  );

  useEffect(() => {
    if (
      (!buscandoAssinatura && !assinatura) ||
      (assinatura && assinatura.status == 0)
    ) {
      navegacao('/estudar/assinar');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assinatura, buscandoAssinatura]);

  useEffect(() => {
    if (assinatura && assinatura.status && curso?.id && avaliacao?.id) {
      setTimeout(() => {
        navegacao(`/estudar/curso/${curso.slug}/avaliacao/${avaliacao.id}`);
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curso, avaliacao, assinatura]);

  return (
    <div className="animate__animated animate__fadeIn mh-100 d-flex justify-content-center align-items-center flex-column py-5">
      {!buscandoAvaliacao && !avaliacao ? (
        <SemRegistros
          carregando={false}
          registros={false}
          titulo="Nenhuma avaliação encontrada!"
          subtitulo="As próximas avaliações para seu curso ainda não foram criadas! Pedimos para que aguarde enquanto nosso time trabalha para solucionar esse caso."
        />
      ) : (
        <Carregando
          titulo="Buscando sua próxima avaliação..."
          subtitulo="Você será redirecionado automaticamente para sua avaliação."
        />
      )}
    </div>
  );
};

export default Processar;
